export default "__VITE_ASSET__CCvxAJsg__"